import { Component, Input } from '@angular/core';

@Component({
  selector: 'info-badge',
  templateUrl: './info-badge.component.html',
  standalone: false,
})
export class InfoBadgeComponent {
  @Input() label: string;
  @Input() tooltip: string;
}
